export default __webpack_public_path__ + "assets/simg3_1simg3.aa1e2f0c.avif";